<template>
  <div>
    <h1>Administrateurs </h1>

    <va-card >
    
      <div class="row align--center">
        <div class="flex xs12 md6">
          <va-input
            :value="term"
            :placeholder="$t('tables.searchByName')"
            @input="search"
            removable
          >
            <va-icon name="fa fa-search" slot="prepend" />
          </va-input>
        </div>

        <div class="flex xs12 md3 offset--md3">
          <va-select
            v-model="perPage"
            :label="$t('tables.perPage')"
            :options="perPageOptions"
            noClear
          />
        </div>
      </div>
      
      
      <va-data-table
        :fields="fields"
        :data="filteredData"
        :per-page="parseInt(perPage)"
      >

      <template slot="actions" slot-scope="props">
        <va-popover placement="top"  title="Detail">
          <va-button @click="showAdminDetail(props.rowData)" flat small color="gray" icon="fa fa-eye" />
        </va-popover>

        <va-popover placement="top" title="Edit">
          <va-button @click="edit(props.rowData)" flat small color="gray" icon="fa fa-pencil" />
        </va-popover>

      </template>

      </va-data-table>
  </va-card>

    <!-- modal showAdminModal -->

        <va-modal size="large" v-model="showAdminModal" title="Administrateur">
          <div class="row" v-if="adminInfo">
          <div class="flex xs6">
            <h3>
              <label for="">
                Nom complet : {{adminInfo.full_name}}
              </label>
            </h3>
            <h3>
              <label for="">
                Téléphone : {{adminInfo.phone}}
              </label>
            </h3>
          
          </div>
          <div class="flex xs6">
            <h3>
              <label for="">
                E-mail : {{adminInfo.email}}
              </label>
            </h3>
          
          </div>
          </div>
        </va-modal>

            <!-- modal showAdminModal -->

        <va-modal size="large" v-model="showAdminEditModal" title="Edit">
          <div class="row" v-if="adminInfo">
          <div class="flex xs6">
            <h3>
              <label for="">
                Nom complet : {{adminInfo.full_name}}
              </label>
            </h3>
            <h3>
              <label for="">
                Téléphone : {{adminInfo.phone}}
              </label>
            </h3>
          
          </div>
          <div class="flex xs6">
            <h3>
              <label for="">
                E-mail : {{adminInfo.email}}
              </label>
            </h3>
          
          </div>
          </div>
        </va-modal>

  </div>

</template>

<script>
import { debounce } from 'lodash'
import service from "../providers/service";

export default {
  data () {
    return {
      showAdminModal: false,
      showAdminEditModal: false,
      adminInfo: null,
      admin: [],
      term: null,
      data : [],
      perPage: '6',
      perPageOptions: ['4', '6', '10']
    }
  },
  computed: {
    fields () {
      return [
        {
          name: 'full_name',
          title: 'Nom complet',
          sortField: 'full_name'
        },
        {
          name: 'username',
          title: 'Pseudonyme',
          sortField: 'username'
        },
        {
          name: 'phone',
          title: 'Téléphone',
          sortField: 'phone'
        }, 
        {
          name: 'email',
          title: 'E-mail',
          sortField: 'email'
        },
        {
          name: '__slot:actions',
          dataClass: 'text-right',
        }
      ]
    },
     filteredData () {
      if (!this.term || this.term.length < 1) {
        return this.data
      }

      return this.data.filter(item => {
        return item.full_name.toLowerCase().startsWith(this.term.toLowerCase())
      })
    },
  },
  methods: {
     search: debounce(function (term) {
      this.term = term
    }, 400),

    edit(admin){
      console.log(admin);
      this.adminInfo = admin;
      this.showAdminEditModal = true;
    },

    showAdminDetail(admin){
      console.log(admin);
      this.adminInfo = admin;

      this.showAdminModal = true;
    },

    getListAdmins(){

      service.getAdmins(localStorage.userAccesstoken).then( res => {
  
        if(res.status === 200){

          this.data = res.data;
        }
      })

    }

  },
  mounted(){
    this.getListAdmins();
  }
}
</script>

<style lang="scss">
</style>